import type { BoardSetting } from './board-settings-client.type';

type BoardSettingAction =
  | { type: 'SET_BOARD_SETTING'; payload: BoardSetting }
  | { type: 'UPDATE_FIELD'; field: keyof BoardSetting; value: BoardSetting[keyof BoardSetting] };

/**
 * A function that acts as a reducer for BoardSetting based on BoardSettingAction types.
 *
 * @param {BoardSetting} state - The current state of the board setting
 * @param {BoardSettingAction} action - The action to perform on the board setting
 * @returns {BoardSetting} - The new state of the board setting
 */
function boardSettingReducer(state: BoardSetting, action: BoardSettingAction): BoardSetting {
  switch (action.type) {
    case 'SET_BOARD_SETTING':
      return action.payload;
    case 'UPDATE_FIELD':
      return {
        ...state,
        [action.field]: action.value,
      };
    default:
      return state;
  }
}

export { boardSettingReducer };
export type { BoardSettingAction };
